import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  FormDecoratorBlueprint,
  createScaffolderFormDecorator,
} from '@backstage/plugin-scaffolder-react/alpha';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';

// Prefills the owner fields of CaaS templates from the signed-in user's
// Microsoft profile (same data the Settings page shows — comes from the
// sign-in token, no catalog User entity / Directory.Read.All needed). Only
// touches fields that already exist in the form state (templates give them
// default: ''), and never overwrites a non-empty value.
const userPrefillDecorator = createScaffolderFormDecorator({
  id: 'caas.user-prefill',
  deps: { auth: microsoftAuthApiRef },
  decorator: async (ctx, { auth }) => {
    const profile = await auth.getProfile().catch(() => undefined);
    if (!profile) return;
    ctx.setFormState(state => {
      const next = { ...state };
      if ('ownerName' in next && !next.ownerName && profile.displayName) {
        next.ownerName = profile.displayName;
      }
      if ('ownerEmail' in next && !next.ownerEmail && profile.email) {
        next.ownerEmail = profile.email;
      }
      return next;
    });
  },
});

export const scaffolderUserPrefillModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    FormDecoratorBlueprint.make({ params: { decorator: userPrefillDecorator } }),
  ],
});
